import React, { useContext } from "react";
import dayjs from "dayjs";
import { Context } from "../index";
import { BackTop, Col, FloatButton, Layout, Row } from "antd";
import { ModalMessage } from "./ModalMessage";
import { ModalRedirect } from "./ModalRedirect";
import { observer } from "mobx-react-lite";
import { logo } from "../utils/svgs";
import { NavLink } from "react-router-dom";

const { Footer, Content } = Layout;

export const AppFooter = observer(() => {
  const { modalStore } = useContext(Context);

  return (
    <Footer className="footer">
      <Content
        style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}
      >
        <div className="logo cursor-pointer">
          <NavLink to={"/"}>{logo()}</NavLink>
        </div>
        <Row className="contacts">
          <Col md={12} xs={24}>
            <strong>Mississauga Office:</strong>
            <p>6910 Avila Road</p>
            <p>L5N 1S1</p>
            <p>Mississauga, Ontario, Canada</p>
            <p>Phone: +1-416 829 9243</p>
            <p>
              Email:{" "}
              <a href="mailto:info@RewardsBridge.com">
                info@RewardsBridge.com
              </a>
            </p>
          </Col>
          <Col md={12} xs={24}>
            <strong>Abu Dhabi office:</strong>
            <p>Al Nahda Tower, Abu Dhabi, Suite 1902</p>
            <p>Corniche Road</p>
            <p>Abu Dhabi, United Arab Emirates</p>
            <p>Phone: +971 54 339 8667</p>
            <p>
              Email:{" "}
              <a href="mailto:info@RewardsBridge.com">
                info@RewardsBridge.com
              </a>
            </p>
          </Col>
        </Row>

        <div className="copyright">
          Copyright &copy; {dayjs().format("YYYY")} Rewards Bridge Consulting
          Inc. (RBC)
        </div>

        <FloatButton.BackTop>
          <div className="goTop">
            <i className="fas fa-arrow-circle-up"></i>
          </div>
        </FloatButton.BackTop>
      </Content>
      <ModalMessage open={modalStore.messageModal} />
      <ModalRedirect open={modalStore.redirectModal} />
    </Footer>
  );
});
